export function getEmojiCode(
  emoji: string,
  excludefe0f: boolean = false
): string {
  return [...emoji]
    .map((e) => e.codePointAt(0)?.toString(16))
    .filter((e) => {
      return !e || (!excludefe0f && e !== 'fe0f');
    })
    .join(`_`);
}
